import React, { lazy, useEffect, useState } from "react";
import "./Layout.scss";
import { useAppSelector } from "@App/hooks/hooks";
import AppRoutes from "@Src/routes/route";
import { Sidebar } from "@Components/UI/sidebar/Sidebar";
import { useLocation } from "react-router-dom";
import { AppRouteURL } from "@Src/routes/app-route-urls";
import { useGet } from "@Src/app/hooks/useGet/useGet";
import { HOME_API_CONSTANTS } from "@Constants/api-constants/home/home.constant";
import { APIEnv } from "@Src/services/learning/baseInterfaces";
import { LocalStorageDataModel } from "@Constants/local-storage-data-model";
import { getData } from "@Src/services/learning/global.service";
import PreservePlatformPremium from "@Src/routes/premiumUrl";

const HeaderIndex = lazy(() =>
  import("@Features/header").then(({ HeaderIndex }) => ({
    default: HeaderIndex,
  }))
);
const Footer = lazy(() =>
  import("@Src/features/footer/footer").then(({ Footer }) => ({
    default: Footer,
  }))
);

const Layout = () => {
  const globalSlice = useAppSelector((state) => state.global);
  const [globalSlicea, setGlobalSliceb] = useState({ showWebSidebar: false });
  const [isSidebar, setIsSideBar] = useState(true);
  const location = useLocation();
  const token = localStorage.getItem(LocalStorageDataModel.AUTH_TOKEN);
  const userName = localStorage.getItem(LocalStorageDataModel.USER_NAME);
  const isSpinnerVisible = useAppSelector((state) => state.global);
  const [showFooter, setShowFooter] = useState(false);
  const [showToast, setShowToast] = useState(true);
  const [userSubscriptionData, setuserSubscriptionData] = useState<any>(null);

  let isPremium = false;
  if (window.location.href.includes('platform=premium') || location.pathname.includes("checkout") || location.pathname.includes("thank-you") || location.pathname.includes("payment/invoice")) {
    isPremium = true;
}
  useEffect(() => {
    if (token) {
      getUserSubscriptionNotification();
    }
  }, [token, location]);

  const getUserSubscriptionNotification = () => {
    getData(
      HOME_API_CONSTANTS.SUBSCRIPTION_NOTIFICATION,
      {},
      "",
      APIEnv.LEARNING
    )
      .then((res) => {
        if (res?.ResponseType == "SUCCESS") {
          if (
            !location.pathname.includes("/thank-you/") &&
            !location.pathname.includes("/payment/") &&
            !location.pathname.includes("/checkout/") &&
            !location.pathname.includes("/collaborate-with-us")
          ) {
            setuserSubscriptionData(res?.data);
          } else {
            setuserSubscriptionData(null);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (
      location &&
      (location.pathname === "/" ||
        location.pathname === "/checkout/information" ||
        location.pathname === "/checkout/payment" ||
        location.pathname.includes(AppRouteURL.PAYMENT_FAILED) ||
        location.pathname.includes(AppRouteURL.THANK_YOU_PURCHASE) ||
        location.pathname.includes(AppRouteURL.ORDER_DETAIL))
    ) {
      setIsSideBar(false);
    } else {
      setIsSideBar(true);
    }
    renderFooter();
  }, [location]);

  const shouldShowFooter =
    globalSlice?.showFooter &&
    location.pathname !== "/checkout/information" &&
    location.pathname !== "/checkout/payment";

  const renderFooter = () => {
    setShowFooter(false);
    setTimeout(() => {
      setShowFooter(true);
    }, 500);
  };

  const getToastText = () => {
    let str = "";
    if (userSubscriptionData?.USER_SUBSCRIBED == "FREE_TRIAL") {
      let points  = +(userSubscriptionData?.planconfig?.FREE_TRIAL)
      if(!points) {
        setShowToast(false)
        return ""
      }
      if (userSubscriptionData?.trial_details?.length < points) {
        const value = points - userSubscriptionData?.trial_details?.length;
        str = `Hi ${userName}! You have ${value} remaining free recorded ${value == 1 ? "session" : "sessions"
          }. Keep exploring and make the most out of them!`;
      } else {
        str = `<a href='/learning/#pricing-section'>Hi ${userName}! You have used both of your free sessions available in your free trial. But don’t worry—you can still register for other Taxmann’s events! Subscribe to <b><u>Taxmann.com | Learning</u></b> to continue learning.</a>`;
      }
    } else if (userSubscriptionData?.USER_SUBSCRIBED == "ANNUALLY"){
      let points  = +(userSubscriptionData?.planconfig?.ANNUALLY)
      if(!points) {
        setShowToast(false)
        return ""
      }
      if (userSubscriptionData?.subscription_free_details?.length < points) {
        const value = points - userSubscriptionData?.subscription_free_details?.length;
        str = `Hi ${userName}! You have ${value} free ${value == 1 ? "workshop" : "workshops"
          } remaining. Keep exploring and make the most out of them!`;
      } else {
        str = `Hi ${userName}! You’ve used all 5 of your free workshops. But don’t worry—you can still register for other Taxmann’s webinars, masterclasses and workshops!`;
      }
    }
    else if (userSubscriptionData?.USER_SUBSCRIBED == "COMPLIMENTARY"){
          let points  = +(userSubscriptionData?.planconfig?.COMPLIMENTARY)
      if(!points) {
        setShowToast(false)
        return ""
      }
      if (userSubscriptionData?.complimentary_details?.length < points) {
        const value = points - userSubscriptionData?.complimentary_details?.length;
        str = `Hi ${userName}! You have ${value} remaining free recorded ${value == 1 ? "session" : "sessions"
          }. Keep exploring and make the most out of them!`;
      } else {
        str = `<a href='/learning/#pricing-section'>Hi ${userName}! You have used all 3 of your free sessions available in your complimentary plan. But don’t worry—you can still register for other Taxmann’s events! Subscribe to <b><u>Taxmann.com | Learning</u></b> to continue learning.</a>`;
      }
    }
    if(!str) {
      setShowToast(false)
    }
    return str;
  };
  const [showPreview, setShowPreview] = useState(false);
  const setDataOnLocalStorageWithExpiry = (key:any, value:any, ttl:any) => {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  };
  const getDataFromLocalStorageWithExpiry = (key:any) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  };
  const PREMIUM_FREE_TRIAL_POPUP = 'premium_free_trial_popup';

    useEffect(() => {
      const handleScroll = () => {
        const popUpScrolled = getDataFromLocalStorageWithExpiry(PREMIUM_FREE_TRIAL_POPUP);
        if (!popUpScrolled) {
          setDataOnLocalStorageWithExpiry(PREMIUM_FREE_TRIAL_POPUP, true, 21600000);
          setShowPreview(true);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);
  const openPreview = () => setShowPreview(true);
  const closePreview = () => setShowPreview(false);

  return (
    <>
    <PreservePlatformPremium>
      {globalSlice?.showProfileSidebar ? (
        <div className="profile-layout">
          <React.Suspense>
            <HeaderIndex />
          </React.Suspense>
          <div className="ui-contents-1 format-user-ui-1">
            <div className="user-ui-page-1">
              <div className="user-ui-contents-1">
                <AppRoutes />
              </div>
            </div>
            {shouldShowFooter && <Footer />}
          </div>
        </div>
      ) : (
        <div className="layout">
          <React.Suspense>
            <HeaderIndex />
          </React.Suspense>
          <div className="layout-container">
            {isSidebar && <Sidebar />}
            <div
              className={
                isSidebar
                  ? `layout-contents-right ${location.pathname == AppRouteURL.COLLABORATE_WITH_US
                    ? "full-layout"
                    : ""
                  }`
                  : "layout-contents layout-landing"
              }
            >
              {["FREE_TRIAL", "ANNUALLY", "COMPLIMENTARY"].includes(
                userSubscriptionData?.USER_SUBSCRIBED
              ) && showToast ? (
                <div className="strip_info">
                  <div
                    dangerouslySetInnerHTML={{ __html: getToastText() }}
                  ></div>
                  <button
                    className="strip_info_close"
                    onClick={() => setShowToast(false)}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.33464 15.8327L4.16797 14.666L8.83464 9.99935L4.16797 5.33268L5.33464 4.16602L10.0013 8.83268L14.668 4.16602L15.8346 5.33268L11.168 9.99935L15.8346 14.666L14.668 15.8327L10.0013 11.166L5.33464 15.8327Z"
                        fill="#110D3F"
                      />
                    </svg>
                  </button>
                </div>
              ) : null}

              <AppRoutes />
              <React.Suspense>
                {shouldShowFooter && showFooter ? <Footer /> : null}
              </React.Suspense>
            </div>
          </div>

        </div>
      )}
{!isPremium &&<div className="adds-new-live">
                            {/* {!showPreview && (
                                <span className="adds-new-toggles" onClick={openPreview}>
                                <img src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/bg-live-adds-thumb.png" alt="thumbnail" />
                                </span>
                            )} */}
                            {showPreview && (
                                <div className="adds-new-live-preview show-adds">
                                <span className="adds-new-close" onClick={closePreview}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 1L1 11M1 1L11 11" stroke="#969BAC" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                {/* <div className="adds-new-live-animation">
                                    <div className="adds-live-contents">
                                    <div className="adds-text-h1">Introducing</div>
                                    <div className="adds-live-logo">
                                        <img src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/live-adds-logo.png" alt="logo" />
                                    </div>
                                    <div className="adds-text-p1">The Unified Search Platform Built Around Your Needs</div>
                                    </div>
                                    <div className="adds-live-footer">
                                    <a href="/premium#free-trial" className="adds-cta-primary">Get 7 Days Free Trial Now</a>
                                    </div>
                                </div> */}
                                </div>
                            )}
                        </div>}

      </PreservePlatformPremium>
    </>
  );
};

export default Layout;
